import utils from '@/utils'

const LIST_PARAMS_KEY = 'studyProgress:listParams'

export const studyProgress = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
    monthlyReportList: {
      data: [],
      meta: {},
    },
    monthlyReportListLoading: false,
    listParams: JSON.parse(localStorage.getItem(LIST_PARAMS_KEY)),
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
    monthlyReportList: (state) => {
      return state.monthlyReportList
    },
    isMonthlyReportListLoading: (state) => {
      return state.monthlyReportListLoading
    },
    listParams: (state) => {
      return state.listParams
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
    setMonthlyReportList(state, data) {
      state.monthlyReportList = data
    },
    setMonthlyReportListLoading(state, data) {
      state.monthlyReportListLoading = data
    },
    setListParams(state, data) {
      localStorage.setItem(LIST_PARAMS_KEY, JSON.stringify(data))
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/study-progress`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'studyProgress/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async getDetail({ commit }, id) {
      commit('setDetailLoading', true)
      const response = await axios.get(`/api/study-progress/${id}`)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async create({ commit, dispatch }, data) {
      commit('setDetailLoading', true)
      let err = null
      try {
        const response = await axios.post('/api/study-progress', data)
        commit('setDetail', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'studyProgress/create', error },
          { root: true }
        )
        err = error
      } finally {
        commit('setDetailLoading', false)
      }
      return err
    },
    async update({ commit, dispatch }, data) {
      commit('setDetailLoading', true)
      let err = null
      try {
        const response = await axios.put(`/api/study-progress/${data.id}`, data)
        commit('setDetail', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'studyProgress/update', error },
          { root: true }
        )
        err = error
      } finally {
        commit('setDetailLoading', false)
      }
      return err
    },
    async delete({ commit, dispatch }, id) {
      commit('setDeleteLoading', true)
      let err = null
      try {
        await axios.delete(`/api/study-progress/${id}`)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'studyProgress/delete', error },
          { root: true }
        )
        err = error
      } finally {
        commit('setDeleteLoading', false)
      }
      return err
    },
    async getMonthlyReportList({ commit, dispatch }, filters) {
      commit('setMonthlyReportListLoading', true)
      try {
        const response = await axios.get(
          `/api/study-progress/monthly-reports`,
          {
            params: filters,
            paramsSerializer: (params) => utils.toQueryString(params),
          }
        )
        commit('setMonthlyReportList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'studyProgress/getMonthlyReportList', error },
          { root: true }
        )
      } finally {
        commit('setMonthlyReportListLoading', false)
      }
    },
  },
}
